import {AsyncLoadResult} from "../../../shared/abstractStore";
import {useLazyQuery} from "@apollo/react-hooks";
import gql from "graphql-tag";
import {mainApiConfig} from "../../../configure/mainApiConfig";
import React from "react";
import {ClaimQueryOptions} from "./useMyClaim";
import {claimPhotoDatesQuery} from "../generated/claimPhotoDatesQuery";


/**
 * Get claim and related state and spec details
 */
export function useClaimPhotoDates(options: ClaimQueryOptions): AsyncLoadResult<claimPhotoDatesQuery> {

    const [load, {loading, error, data, refetch}] = useLazyQuery(
        gql`
            query claimPhotoDatesQuery($id: String!){
                item: claim(id: $id){
                    id,
                    number,
                    equipmentReceived: claimEvent(name: "Claim state changed to Equipment Received.") {
                        id,
                        eventDate
                    }
                    inspectionStart: claimEvent(name: "Claim state changed to Inspection.") {
                        id,
                        eventDate
                    }
                    repairStart: claimEvent(name: "Claim state changed to Repair.") {
                        id,
                        eventDate
                    }
                }
            }
        `, {
            variables: {id: options.id},
            fetchPolicy: options.fetchPolicy ?? mainApiConfig.defaultFetchPolicy,
            pollInterval: options.pollInterval,
            onCompleted: (data) => {
                if (options.onCompleted){
                    options.onCompleted(data);
                }
            }
        }
    )

    // Run the query (unless we are being lazy).
    React.useEffect(() => {
        if (!options.lazy) {
            load();
        }
    }, [options.lazy, load])

    const refresh = React.useCallback(
        async () => {!refetch ? await load() : await refetch();},
        [refetch, load]);

    return React.useMemo(() => ({
        data: data ?? ({} as any),
        refresh: refresh,
        isLoading: loading,
        errors: error
    }), [data, refresh, loading, error]);

}
